export default "__VITE_ASSET__IXmIf3YP__"